import Vue from "vue";
import Router from "vue-router";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {Routers} from './routers'
import {GetToken} from '@/utils'
Vue.use(Router);

let basicRouters = Routers
const router = new Router({
    routes: basicRouters
});
const whitelist = ['/Login']
router.beforeEach((to, from, next) => {
    NProgress.start();
    if (GetToken()) {
        NProgress.done()
        next({
            query: {
                t: +(new Date())
            }
        })
    } else {
        if (whitelist.includes(to.path)) {
            NProgress.done()
            next()
        } else {
            NProgress.done()
            next('/Login')
        }
    }
})
export default router;